<template>
  <div class="App-buttons">
    
    <!-- Show abstain modal if some votes remaining -->
    <div v-if="buttonActionType === 'next-step'">
      <button-component
        direction="back"
        value="Back" />
      &nbsp;&nbsp;
      <button-component
        color="primary"
        value="Next Step"
        :is-disabled="isDisabled"
        field-id="questionButton"
        log-action="next-question"
        @go-next-question="goNextQuestion" />
    </div>

    <div v-else-if="buttonActionType === 'abstain-modal'">
      <button-component
        direction="back"
        value="Back" />
      &nbsp;&nbsp;
      <button 
        type="button" 
        class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored"
        @click="showAbstainModal" 
        :disabled="isDisabled">
        NEXT STEP
      </button>      
    </div>

    <div v-else-if="buttonActionType === 'option-modal'">
      <button-component
        direction="back"
        value="Back" />
      &nbsp;&nbsp;
      <button 
        type="button" 
        class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored"
        @click="showOptionModal" 
        :disabled="isDisabled">
        NEXT STEP
      </button>      
    </div>

  </div>
</template>

<script>
import ButtonComponent from '@/components/Button.vue';

export default {
  components: {
    ButtonComponent
  },
  props: {
    buttonActionType: {
      type: String,
      required: true
    },
    isDisabled: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    showAbstainModal() {
      this.$emit('show-abstain-modal');
    },
    showOptionModal() {
      this.$emit('show-option-modal');
    },
    goNextQuestion() {
      this.$emit('go-next-question');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Questions/Elections/ElectionsButtons.vue